import React from "react";
import styles from "./DroppableArea.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

interface DroppableAreaProps {
    data: any[],
    groupName?: string,
    onChange: (newArray: any[]) => void,
    renderComponent: (item: any, index: number) => React.ReactElement;
}

const DroppableArea: React.FC<DroppableAreaProps> = ({
    data, groupName = "", onChange, renderComponent
}) => {

    const onDragItemStart = (e: React.DragEvent, index: number) => {
        e.dataTransfer.setData('index-' + groupName, index.toString());
        e.dataTransfer.setData('indexParent-' + groupName, groupName);
        e.stopPropagation();
    };

    const onDropItem = (e: React.DragEvent, index: number) => {
        const from = Number(e.dataTransfer.getData('index-' + groupName));
        const parent = e.dataTransfer.getData('indexParent-' + groupName);
        if (groupName && parent != groupName) return;

        // data.sections
        const newItems = [...data];
        const [moved] = newItems.splice(from, 1);
        newItems.splice(index, 0, moved);

        onChange(newItems)
    };

    function findChildBySlot(
        children: React.ReactNode,
        slotName: string
    ): React.ReactNode | null {
        let result: React.ReactNode | null = null;

        React.Children.forEach(children, (child) => {
            if (result) return;
            if (!React.isValidElement(child)) return;

            if (child.props?.['data-slot'] === slotName) {
                result = child.props.children;
                return;
            }

            if (child.props?.children) {
                const found = findChildBySlot(child.props.children, slotName);
                if (found) result = found;
            }
        });

        return result;
    }

    return (
        <>
            <div className="w-full">
                {
                    data.map((item, index) => <div className="w-full"
                        draggable
                        onDragStart={(e) => onDragItemStart(e, index)}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={(e) => onDropItem(e, index)}
                    >
                        {renderComponent(item, index)}
                    </div>)
                }
            </div>
        </>
    );
};

export default DroppableArea;

